import getFormFieldValue from "./getFormFieldValue";
import {
  ADDRESS,
  BUDGET,
  BUDGET_CHAPTER,
  BUDGET_DISPATCHER,
  EVENTS,
  FILES,
  HTML,
  MATRIX,
  ORAL_INTERVIEW,
  SELECT,
  SORTABLE_LIST,
  STRING,
  TAXONOMIES,
  THEMES
} from "../components/Form/SchemaTypes";

function serialize(form, fieldName) {
  // Do not serialize fields starting with "__"
  if (fieldName.match(/^__/)) {
    return;
  }

  const schema = form.schema[fieldName];

  switch (schema.type) {
    case FILES:
      return { blobKeys: getFormFieldValue(form, fieldName) };

    // The oral interview transcript is the server's projection of the persisted
    // messages, so the client never resends content and it cannot diverge from the
    // recorded conversation.
    case ORAL_INTERVIEW:
      return;

    case STRING:
    case HTML:
      return { content: getFormFieldValue(form, fieldName) };

    case THEMES:
    case TAXONOMIES:
    case EVENTS:
    case SORTABLE_LIST:
      return { values: getFormFieldValue(form, fieldName) };

    case BUDGET_DISPATCHER:
      return { weightedOptions: getFormFieldValue(form, fieldName) };

    case BUDGET_CHAPTER:
      return { budgetLineInputOptions: getFormFieldValue(form, fieldName) };

    case ADDRESS:
    case BUDGET:
      return { answers: serializeNestedAnswers(form, schema.fieldNames) };

    case SELECT:
      return { value: getFormFieldValue(form, fieldName) };

    case MATRIX:
      // Can't use `const` here because of lexical constraints of JS, so we use `var`
      // which seems to work.
      var { values, other, otherValue } = getFormFieldValue(form, fieldName);
      return { itemOptions: values, other, otherValue };

    default:
      return getFormFieldValue(form, fieldName);
  }
}

function serializeNestedAnswers(form, fieldNames) {
  return fieldNames.reduce((answers, fieldName) => {
    const data = serialize(form, fieldName);
    return data ? answers.concat([{ fieldName, data }]) : answers;
  }, []);
}

function serializeAnswers(form) {
  const serializedAnswers = [];

  Object.keys(form.schema).forEach(fieldName => {
    // Do not serialize nested fields, their parent will take care of them
    if (form.schema[fieldName].parent) {
      return;
    }

    const data = serialize(form, fieldName);
    if (data) {
      serializedAnswers.push({ fieldName, data });
    }
  });

  return serializedAnswers;
}

export default serializeAnswers;
